import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Box, Heading, SimpleGrid } from '@hover/blueprint';
import RestorationBlogCard from './RestorationBlogCard';
import { IProsRestorationBlogArticle } from '../../../interfaces/IRestorationBlogArticle';

const latestArticles = graphql`
  query ProsRestorationBlogArticles {
    allContentfulBlogPost(
      sort: { order: DESC, fields: publishDate }
      limit: 3
    ) {
      nodes {
        slug
        title
        heroImage {
          gatsbyImageData(height: 226)
        }
      }
    }
  }
`;

interface ILatestArticles {
  allContentfulBlogPost: {
    nodes: Array<IProsRestorationBlogArticle>;
  };
}

const ExploreMore: React.FC = () => {
  const {
    allContentfulBlogPost: { nodes },
  }: ILatestArticles = useStaticQuery(latestArticles);

  return (
    <Box
      maxW="1248px"
      px={{ base: 500, tablet: '56px', desktop: 500 }}
      w="100%"
      flexDir="column"
      alignItems="center"
      mb={1000}
    >
      <Heading
        as="h2"
        textAlign="center"
        isLight
        size={{ base: 500, tablet: 600, desktop: 700 }}
        marginBottom={{ base: 700, tablet: '80px', desktop: '80px' }}
      >
        Explore more
      </Heading>
      <SimpleGrid w="100%" columns={{ base: 1, desktop: 3 }} spacing={600}>
        {nodes.map(node => (
          <RestorationBlogCard blog={node} key={node.slug} />
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default ExploreMore;
